import {
    StyleSheet,
    Font
} from "@react-pdf/renderer"

import jostFont from "../../../assets/fonts/jost-v12-latin-700.ttf"
import poppinsFont from "../../../assets/fonts/poppins-v19-latin-regular.ttf"

// Register font
Font.register({ 
    family: "Poppins", 
    format: "truetype",
    fonts: [ { src: poppinsFont }, ] 
})
Font.register({ 
    family: "Jost", 
    format: "truetype",
    fonts: [ { src: jostFont }, ] 
})

export const styles = StyleSheet.create({
    page: {
        backgroundColor: "#fff",
        fontFamily: "Helvetica",
        fontSize: 10,
        padding: 30,
    },

    h1: {
        fontSize: 20,
        fontFamily: "Jost",
        color: "#1B1464",
        marginBottom: 5,
        textAlign: "center",
        textTransform: "uppercase",
    },

    h2: {
        fontSize: 12,
        fontFamily: "Jost",
        color: "#1B1464",
        marginBottom: 5,
    },

    p: {
        marginBottom: 3,
    },

    rum: {
        textAlign: "center",
        marginBottom: 25,
        fontSize: 14,
        fontWeight: 700,
    },

    flexParentSection: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        paddingTop: 20,
    },

    section: {
        width: "49%",
        borderWidth: 1,
        borderColor: "#EEEEF3",
        padding: 20,
        marginBottom: 10,
        fontFamily: "Poppins",
    },

    fullSection: {
        borderWidth: 1,
        borderColor: "#EEEEF3",
        padding: 20,
        marginBottom: 20,
        fontFamily: "Poppins",
    },

    data: {
        marginBottom: 4,
    },

    bic: {
        marginBottom: 8
    },

    iban: {
        marginTop: 8,
        marginBottom: 8
    },

    number: {
        padding: 5,
        backgroundColor: "#BBCCE7",
        fontFamily: "Jost",
        letterSpacing: 6,
        borderBottomWidth: 1,
        borderColor: "000",
    },

    explanation: {
        fontSize: 9,
        paddingLeft: 5,
    },

    bottom: {
        fontSize: 8,
        fontFamily: "Poppins",
    },
})